const ResourceHelper = function(httpClient, logger) {
  return {
    /**
     * Generate the CRUD methods for a resource.
     * @param resourceRoute: The API route for the resource.
     * @param options: Additional options to customize the caller.
     */
    generateCrudCallers: function(resourceRoute, options) {
      options = options || {};
      return {
        list: this.generateListCaller(resourceRoute, options),
        getList: this.generateGetCaller(resourceRoute, options),
        collectionAreaList: this.generateListCallerForWaste(
          resourceRoute,
          options
        ),
        List: this.generateListCallerForWaste(resourceRoute, options),
        // wasteAreaList: this.generateListCallerForWaste(
        //   resourceRoute,
        //   options
        // ),
        collectionSecondaryTripList: this.generateListCallerForSecondaryTrip(
          resourceRoute,
          options
        ),
        collectionPrimaryTripList: this.generateListCallerForPrimaryTrip(
          resourceRoute,
          options
        ),
        collectionFuelList: this.generateListCallerForFuel(
          resourceRoute,
          options
        ),
        collectionCitysList: this.generateListCallerForCitys(
          resourceRoute,
          options
        ),
        collectionDumpyardList: this.generateListCallerForDumpyard(
          resourceRoute,
          options
        ),
        collectionSegregationList: this.generateListCallerForSegregation(
          resourceRoute,
          options
        ),
        collectionTransportList: this.generateListCallerForTransport(
          resourceRoute,
          options
        ),
        collectionVehiclesList: this.generateListCallerForVehicles(
          resourceRoute,
          options
        ),
        collectionMisCellaneous: this.generateListCallerForMisCellaneous(
          resourceRoute,
          options
        ),

        collectionWasteRecycleList: this.generateListCallerForWasteRecycle(
          resourceRoute,
          options
        ),
        collectionSurveysList: this.generateListCallerForSurveys(
          resourceRoute,
          options
        ),
        roleListLowerThanCurrentUserRank: this.generateListRankCaller(
          resourceRoute,
          options
        ),
        listOfUsersWithRoleInfo: this.generateUsersListWithRoleInfo(
          resourceRoute,
          options
        ),
        listOfStaffUsers: this.generateStaffUsersListWithRoleInfo(
          resourceRoute,
          options
        ),
        getListByPost:this.generatePostCaller(resourceRoute, options),
        find: this.generateFindCaller(resourceRoute, options),
        update: this.generateUpdateCaller(resourceRoute, options),
        create: this.generateCreateCaller(resourceRoute, options),
        deleteOne: this.generateDeleteOneCaller(resourceRoute, options),
        deleteMany: this.generateDeleteManyCaller(resourceRoute, options),
      };
    },

    generateListCallerForSurveys: function(resourceRoute, options) {
   
      return function(params) {
        
  
        return httpClient
          .get('/survey/list', params)
          .then(function(response) {
         
            return response
          })
          .catch(function(error) {
            logger.error(resourceRoute + '.list error:\n', error)
            throw error
          })
      }
    },

    generateListRankCaller: function(resourceRoute, options) {
      return function(params) {
       

        if (!params) {
          params = { isDeleted: false };
        } else if (!params.isDeleted) {
          params.isDeleted = false;
        }

        if (options.filterDeleted === false) {
          delete params.isDeleted;
        }

        return httpClient
          .get(resourceRoute + "/LessThanCurrentUserRank", params)
          .then(function(response) {
          
            return response;
          })
          .catch(function(error) {
            logger.error(resourceRoute + ".list error:\n", error);
            throw error;
          });
      };
    },

    generateUsersListWithRoleInfo: function(resourceRoute, options) {
      return function(params) {

        return httpClient
          .get("userWithRoleInfo", params)
          .then(function(response) {
            
            return response;
          })
          .catch(function(error) {
            logger.error(resourceRoute + ".list error:\n", error);
            throw error;
          });
      };
    },

    generateStaffUsersListWithRoleInfo: function(resourceRoute, options) {
      return function(params) {
        

        // if (!params) {
        //   params = { isDeleted: false }
        // } else if (!params.isDeleted) {
        //   params.isDeleted = false
        // }

        // if (options.filterDeleted === false) {
        //   delete params.isDeleted
        // }

        return httpClient
          .get("register/user", params)
          .then(function(response) {
           
            return response;
          })
          .catch(function(error) {
            logger.error(resourceRoute + ".list error:\n", error);
            throw error;
          });
      };
    },

    generateListCaller: function(resourceRoute, options) {
      return function(params) {
        

        if (!params) {
          params = { isDeleted: false };
        } else if (!params.isDeleted) {
          params.isDeleted = false;
        }

        if (options.filterDeleted === false) {
          delete params.isDeleted;
        }

        return httpClient
          .get(resourceRoute, params)
          .then(function(response) {
            
            return response;
          })
          .catch(function(error) {
            logger.error(resourceRoute + ".list error:\n", error);
            throw error;
          });
      };
    },

    generateGetCaller: function(resourceRoute, options) {
      return function(params) {
       

        return httpClient
          .get(resourceRoute, params)
          .then(function(response) {
           
            return response
          })
          .catch(function(error) {
            logger.error(resourceRoute + '.list error:\n', error)
            throw error
          })
      }
    },
    generateListCallerForCitys: function(resourceRoute, options) {
   
      return function(params) {
       

        return httpClient
          .get("/all/city", params)
          .then(function(response) {
          
            return response;
          })
          .catch(function(error) {
            logger.error(resourceRoute + ".list error:\n", error);
            throw error;
          });
      };
    },

    generatePostCaller: function(resourceRoute, options) {
      return function(params,filters) {
           

        let parameters = `page=${params.page}&limit=${params.limit}`;
        if(params.cityId){
          parameters += `&cityId=${params.cityId}`;
        }
        if(params.sortBy){
          parameters += `&sortBy=${params.sortBy}`;
          parameters += `&sortOrder=${params.sortOrder}`;
        }
        if(params.searchString){
          parameters += `&searchString=${params.searchString}`;
        }
        if(parameters.status){
          parameters += `&status=${params.status}`;
        }
        if(params.startDate){
          parameters += `&startDate=${params.startDate}`;
        }
        if(params.endDate){
          parameters += `&endDate=${params.endDate}`;
        }
       


        return httpClient
          .post(`${resourceRoute}?${parameters}` ,{filters:filters}, )
          // .post(`${resourceRoute}?${params}` )
          .then(function(response) {
           
            return response
          })
          .catch(function(error) {
            logger.error(resourceRoute + '.list error:\n', error)
            throw error
          })
      }
    },

    generateListCallerForPrimaryTrip: function(resourceRoute, options) {
    
      return function(params) {
       

        return httpClient
          .get("/trip/primary-trip", params)
          .then(function(response) {
           
            return response;
          })
          .catch(function(error) {
            logger.error(resourceRoute + ".list error:\n", error);
            throw error;
          });
      };
    },

    generateListCallerForSecondaryTrip: function(resourceRoute, options) {
    
      return function(params) {
      

        return httpClient
          .get("/trip/secondary-trip", params)
          .then(function(response) {
           
            return response;
          })
          .catch(function(error) {
            logger.error(resourceRoute + ".list error:\n", error);
            throw error;
          });
      };
    },

    generateListCallerForFuel: function(resourceRoute, options) {
  
      return function(params) {
       

        return httpClient
          .get("/fuel-expense/list", params)
          .then(function(response) {
          
            return response;
          })
          .catch(function(error) {
            logger.error(resourceRoute + ".list error:\n", error);
            throw error;
          });
      };
    },
    generateListCallerForDumpyard: function(resourceRoute, options) {
   
      return function(params) {
      

        return httpClient
          .get("/dumpyard/list", params)
          .then(function(response) {
           
            return response;
          })
          .catch(function(error) {
            logger.error(resourceRoute + ".list error:\n", error);
            throw error;
          });
      };
    },
    generateListCallerForSegregation: function(resourceRoute, options) {
   
      return function(params) {
       

        return httpClient
          .get("/segregation/list", params)
          .then(function(response) {
           
            return response;
          })
          .catch(function(error) {
            logger.error(resourceRoute + ".list error:\n", error);
            throw error;
          });
      };
    },
    generateListCallerForTransport: function(resourceRoute, options) {
   
      return function(params) {
        

        return httpClient
          .get("/transfer/list", params)
          .then(function(response) {
            
            return response;
          })
          .catch(function(error) {
            logger.error(resourceRoute + ".list error:\n", error);
            throw error;
          });
      };
    },
    generateListCallerForVehicles: function(resourceRoute, options) {
   
      return function(params) {
       

        return httpClient
          .get("/vehicle/list", params)
          .then(function(response) {
            
            return response;
          })
          .catch(function(error) {
            logger.error(resourceRoute + ".list error:\n", error);
            throw error;
          });
      };
    },
    generateListCallerForMisCellaneous: function(resourceRoute, options) {
      return function(params) {
      

        return httpClient
          .get("/miscellaneous/list", params)
          .then(function(response) {
         
            return response;
          })
          .catch(function(error) {
            logger.error(resourceRoute + ".list error:\n", error);
            throw error;
          });
      };
    },

    // ?page=1&limit=10

    generateListCallerForWasteRecycle: function(resourceRoute, options) {
      return function(params) {
      

        return httpClient
          .get("/waste-recycle/list", params)
          .then(function(response) {
           
            return response;
          })
          .catch(function(error) {
            logger.error(resourceRoute + ".list error:\n", error);
            throw error;
          });
      };
    },

    generateListCallerForWaste: function(resourceRoute, options) {
      return function(params) {
       

        return httpClient
          .get(resourceRoute, params)
          .then(function(response) {
           
            return response;
          })
          .catch(function(error) {
            logger.error(resourceRoute + ".list error:\n", error);
            throw error;
          });
      };
    },

    generateFindCaller: function(resourceRoute, options) {
      return function(_id, params) {
       

        return httpClient
          .get(resourceRoute + "/" + _id, params)
          .then(function(response) {
          
            return response;
          })
          .catch(function(error) {
            logger.error(resourceRoute + ".find error:\n", error);
            throw error;
          });
      };
    },
    generateUpdateCaller: function(resourceRoute, options) {
      return function(_id, payload) {
        delete payload.createdAt;
        delete payload.updatedAt;
        delete payload.isDeleted;
      

        return httpClient
          .put(resourceRoute + "/" + _id, payload)
          .then(function(response) {
          
            return response;
          })
          .catch(function(error) {
            logger.error(resourceRoute + ".update error:\n", error);
            throw error;
          });
      };
    },
    generateCreateCaller: function(resourceRoute, options) {
      return function(payload) {
     

        return httpClient
          .post(resourceRoute, payload)
          .then(function(response) {
          
            return response;
          })
          .catch(function(error) {
            logger.error(resourceRoute + ".create error:\n", error);
            throw error;
          });
      };
    },
    generateDeleteOneCaller: function(resourceRoute, options) {
      return function(_id, hardDelete) {
        hardDelete = hardDelete || false;
       

        return httpClient
          .delete(resourceRoute + "/" + _id, { hardDelete: hardDelete })
          .then(function(response) {
       
            return response;
          })
          .catch(function(error) {
            logger.debug(resourceRoute + ".delete error:\n", error);
            throw error;
          });
      };
    },
    generateDeleteManyCaller: function(resourceRoute, options) {
      return function(payload) {
      

        return httpClient
          .delete(resourceRoute, payload)
          .then(function(response) {
         
            return response;
          })
          .catch(function(error) {
            logger.debug(resourceRoute + ".delete error:\n", error);
            throw error;
          });
      };
    },
    /**
     * Generate the association methods for a resource. The parameters are explained below with examples
     * using the context of a user and their shopping cart items.
     * @param ownerRoute: The API route for the owner resource,                    Ex: user
     * @param associationName: The name of the association for the owner resource, Ex: shoppingCartItems
     * @param associationRoute: The API route for the association,                 Ex: cart-item
     * childName: The name of the child/association resource,                      Ex: storeItem
     * @param options: Additional options to customize the caller.                Ex: cart-item
     *
     * The generated methods will correspond with the following routes:
     *
     * DELETE /user/{ownerId}/cart-item             Remove multiple storeItems from a user's list of shoppingCartItems
     * GET /user/{ownerId}/cart-item                Get all of the storeItems for a user
     * POST /user/{ownerId}/cart-item               Add multiple storeItems to a user's list of shoppingCartItems
     * DELETE /user/{ownerId}/cart-item/{childId}   Remove a single storeItem from a user's list of shoppingCartItems
     * PUT /user/{ownerId}/cart-item/{childId}      Add a single storeItem to a user's list of shoppingCartItems
     */
    generateAssociationCallers: function(
      ownerRoute,
      associationName,
      associationRoute,
      options
    ) {
      options = options || {};
      var resourceMethodName =
        associationName[0].toUpperCase() + associationName.slice(1);
      var callers = {};
      callers[
        "get" + resourceMethodName
      ] = this.generateGetAssociationsAssociationCaller(
        ownerRoute,
        associationRoute,
        resourceMethodName,
        options
      );
      callers[
        "addOne" + resourceMethodName
      ] = this.generateAddOneAssociationCaller(
        ownerRoute,
        associationRoute,
        resourceMethodName,
        options
      );
      callers[
        "removeOne" + resourceMethodName
      ] = this.generateRemoveOneAssociationCaller(
        ownerRoute,
        associationRoute,
        resourceMethodName,
        options
      );
      callers[
        "addMany" + resourceMethodName
      ] = this.generateAddManyAssociationCaller(
        ownerRoute,
        associationRoute,
        resourceMethodName,
        options
      );
      callers[
        "removeMany" + resourceMethodName
      ] = this.generateRemoveManyAssociationCaller(
        ownerRoute,
        associationRoute,
        resourceMethodName,
        options
      );

      return callers;
    },
    generateGetAssociationsAssociationCaller: function(
      ownerRoute,
      associationRoute,
      resourceMethodName,
      options
    ) {
      return function(ownerId, params) {
        var methodName = ownerRoute + ".get" + resourceMethodName;
       

        if (!params) {
          params = { isDeleted: false };
        } else if (!params.isDeleted) {
          params.isDeleted = false;
        }

        if (options.filterDeleted === false) {
          delete params.isDeleted;
        }

        return httpClient
          .get(ownerRoute + "/" + ownerId + "/" + associationRoute, params)
          .then(function(response) {
           
            return response;
          })
          .catch(function(error) {
            logger.error(methodName + " error:\n", error);
            throw error;
          });
      };
    },
    generateAddOneAssociationCaller: function(
      ownerRoute,
      associationRoute,
      resourceMethodName,
      options
    ) {
      return function(ownerId, childId, payload) {
        var methodName = ownerRoute + ".addOne" + resourceMethodName;
       

        return httpClient
          .put(
            ownerRoute + "/" + ownerId + "/" + associationRoute + "/" + childId,
            payload
          )
          .then(function(response) {
      
            return response;
          })
          .catch(function(error) {
            logger.error(methodName + " error:\n", error);
            throw error;
          });
      };
    },
    generateRemoveOneAssociationCaller: function(
      ownerRoute,
      associationRoute,
      resourceMethodName,
      options
    ) {
      return function(ownerId, childId) {
        var methodName = ownerRoute + ".removeOne" + resourceMethodName;
       

        return httpClient
          .delete(
            ownerRoute + "/" + ownerId + "/" + associationRoute + "/" + childId
          )
          .then(function(response) {
          
            return response;
          })
          .catch(function(error) {
            logger.error(methodName + " error:\n", error);
            throw error;
          });
      };
    },
    generateAddManyAssociationCaller: function(
      ownerRoute,
      associationRoute,
      resourceMethodName,
      options
    ) {
      return function(ownerId, payload) {
        var methodName = ownerRoute + ".addMany" + resourceMethodName;
       

        return httpClient
          .post(ownerRoute + "/" + ownerId + "/" + associationRoute, payload)
          .then(function(response) {
    
            return response;
          })
          .catch(function(error) {
            logger.error(methodName + " error:\n", error);
            throw error;
          });
      };
    },
    generateRemoveManyAssociationCaller: function(
      ownerRoute,
      associationRoute,
      resourceMethodName,
      options
    ) {
      return function(ownerId, payload) {
        var methodName = ownerRoute + ".removeMany" + resourceMethodName;
       

        return httpClient
          .delete(ownerRoute + "/" + ownerId + "/" + associationRoute, payload)
          .then(function(response) {
         
            return response;
          })
          .catch(function(error) {
            logger.error(methodName + " error:\n", error);
            throw error;
          });
      };
    },
  };
};

export default ResourceHelper;



// WEBPACK FOOTER //
// ./src/plugins/restful-resource-utility.js